import React, {Component} from 'react';

import styled from 'styled-components';
import Header from "../template/header";
import Leftnav from "../template/leftnav";
import {mdDownN} from "../../ui/common";

const QuoteTopSimpleGroupStyle = styled.div`
    height: 135px;
    width: 600px;
    ${mdDownN`
        position: relative;
        width: 100%;
        height: ${props=>props.height?'110px':'89px'};
    `}
`;

const QuoteTopSimpleTitleBackgroundStyle = styled.div`
    top: 0px;
    height: 110px;
    width: 600px;
    position: absolute;
    margin: 0;
    left: 0px;
    background: linear-gradient(180deg, #48D08C 0%, #00B6B8 100%); 
    ${mdDownN`
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 100%;
    `}
`;

const QuoteTopSimpleTitleStyle = styled.div`
    top: 33px;
    height: 41px;
    width: 481px;
    position: absolute;
    margin: 0;
    left: 60px;
    font-family: "Stag-Medium", Helvetica, Arial, serif;
    font-size: 32.0px;
    color: #fff;
    text-align: center;
    letter-spacing: 1.0px;
    line-height: 40.0px;
     ${mdDownN`
        position: relative;
        width: 100%;
        top: auto;
        left: auto;
        font-size: 24.0px;
        letter-spacing: 1px;
        line-height: 36px;
    `}
`;

const TopSimple = (props) => {
    const isApplication = props.title==='Application'?'true':'false';
    return (
            <QuoteTopSimpleGroupStyle id="QuoteTopSimple" height={isApplication}>
                <QuoteTopSimpleTitleBackgroundStyle>
                    <QuoteTopSimpleTitleStyle>
                        {props.title ? props.title : 'Quotation'}
                    </QuoteTopSimpleTitleStyle>
                </QuoteTopSimpleTitleBackgroundStyle>
            </QuoteTopSimpleGroupStyle>
    );
}

export default TopSimple;
